var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.5,
    height: 41.375,
    viewBox: "0 0 46.5 41.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_744",
    "data-name": "Raggruppa 744",
    transform: "translate(-19032.5 -15569.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_743",
    "data-name": "Raggruppa 743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_742",
    "data-name": "Raggruppa 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1434",
    "data-name": "Tracciato 1434",
    d: "M12.927,5.875a1.3,1.3,0,0,0-1.4,1.172,1.3,1.3,0,0,0,1.4,1.172c4.621,0,8.38,3.154,8.38,7.032a1.418,1.418,0,0,0,2.793,0C24.1,10.081,19.087,5.875,12.927,5.875Z",
    transform: "translate(19042.521 15569.472)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1435",
    "data-name": "Tracciato 1435",
    d: "M18.683,4.317C12.781,5.433,8,9.721,6.736,15.094a13.237,13.237,0,0,0,3.595,12.5,8.732,8.732,0,0,1,2.575,6.034v2.364a3.607,3.607,0,0,0,2.708,3.372,6.422,6.422,0,0,0,6.436,4.981,6.422,6.422,0,0,0,6.436-4.981,3.607,3.607,0,0,0,2.708-3.372V33.625a8.857,8.857,0,0,1,2.651-6.112,13.4,13.4,0,0,0,3.88-9.332C37.725,9.233,28.672,2.429,18.683,4.317ZM22.05,41.978a3.978,3.978,0,0,1-3.7-2.451h7.39A3.978,3.978,0,0,1,22.05,41.978Zm6.531-5.988a1.25,1.25,0,0,1-1.306,1.182H16.824a1.25,1.25,0,0,1-1.306-1.182V34.807H28.581Zm3.3-10.034a11.359,11.359,0,0,0-3.227,6.488H15.447a11.187,11.187,0,0,0-3.164-6.423A11.05,11.05,0,0,1,9.292,15.585a12.446,12.446,0,0,1,9.925-8.954c8.362-1.581,15.9,4.1,15.9,11.551A11.164,11.164,0,0,1,31.88,25.955Z",
    transform: "translate(19033.701 15566.5)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1436",
    "data-name": "Tracciato 1436",
    d: "M8.189,9.625H5.4A1.3,1.3,0,0,0,4,10.8a1.3,1.3,0,0,0,1.4,1.172H8.189a1.3,1.3,0,0,0,1.4-1.172A1.3,1.3,0,0,0,8.189,9.625Z",
    transform: "translate(19029 15575.225)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1437",
    "data-name": "Tracciato 1437",
    d: "M8.5,8.481,6.521,6.824a1.592,1.592,0,0,0-1.975,0,1.044,1.044,0,0,0,0,1.657l1.975,1.657a1.592,1.592,0,0,0,1.975,0A1.044,1.044,0,0,0,8.5,8.481Z",
    transform: "translate(19029.271 15570.439)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1438",
    "data-name": "Tracciato 1438",
    d: "M8.5,12.449a1.592,1.592,0,0,0-1.975,0L4.546,14.106a1.044,1.044,0,0,0,0,1.657,1.591,1.591,0,0,0,1.975,0L8.5,14.106A1.044,1.044,0,0,0,8.5,12.449Z",
    transform: "translate(19029.271 15579.011)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1439",
    "data-name": "Tracciato 1439",
    d: "M22.314,9.625H19.521a1.3,1.3,0,0,0-1.4,1.172,1.3,1.3,0,0,0,1.4,1.172h2.793a1.3,1.3,0,0,0,1.4-1.172A1.3,1.3,0,0,0,22.314,9.625Z",
    transform: "translate(19054.789 15575.225)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1440",
    "data-name": "Tracciato 1440",
    d: "M22.621,6.824a1.592,1.592,0,0,0-1.975,0L18.671,8.481a1.044,1.044,0,0,0,0,1.657,1.592,1.592,0,0,0,1.975,0l1.975-1.657A1.044,1.044,0,0,0,22.621,6.824Z",
    transform: "translate(19055.063 15570.439)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1441",
    "data-name": "Tracciato 1441",
    d: "M22.621,14.106l-1.975-1.657a1.592,1.592,0,0,0-1.975,0,1.044,1.044,0,0,0,0,1.657l1.975,1.657a1.591,1.591,0,0,0,1.975,0A1.044,1.044,0,0,0,22.621,14.106Z",
    transform: "translate(19055.063 15579.011)",
    fill: "#14bf96",
    stroke: "#14bf95",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.8f26ea378224485e2db1ff9317312a3a.svg";
export { ForwardRef as ReactComponent };